import { adminInstance } from "@/api/instance";

export default async function (counselId) {
  return adminInstance.delete(`/counsel/${counselId}`);
}
